(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[190],{

/***/ 8266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ article_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(5102);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/content-hub-button/content-hub-button.tsx
var content_hub_button = __webpack_require__(9309);
// EXTERNAL MODULE: ./components/content-hub-button/content-hub-button.constants.ts
var content_hub_button_constants = __webpack_require__(1706);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./components/article-bio-block/article-bio-block.module.scss
var article_bio_block_module = __webpack_require__(2457);
var article_bio_block_module_default = /*#__PURE__*/__webpack_require__.n(article_bio_block_module);
;// CONCATENATED MODULE: ./components/article-bio-block/IconAuthorAvatar.tsx


const AuthorAvatar = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "88",
        height: "88",
        viewBox: "0 0 88 88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "44",
                cy: "44",
                r: "44",
                fill: "#B2FCE4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 45.75C48.8325 45.75 52.75 41.8325 52.75 37C52.75 32.1675 48.8325 28.25 44 28.25C39.1675 28.25 35.25 32.1675 35.25 37C35.25 41.8325 39.1675 45.75 44 45.75Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M61.3351 63.6741C59.7699 60.4037 57.3115 57.6429 54.2441 55.7102C51.1767 53.7775 47.6251 52.752 43.9996 52.752C40.374 52.752 36.8224 53.7775 33.7549 55.7102C30.6874 57.6429 28.2292 60.4037 26.6641 63.6741",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 70.25C58.4973 70.25 70.25 58.4973 70.25 44C70.25 29.5025 58.4973 17.75 44 17.75C29.5025 17.75 17.75 29.5025 17.75 44C17.75 58.4973 29.5025 70.25 44 70.25Z",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var IconAuthorAvatar = (AuthorAvatar);

;// CONCATENATED MODULE: ./components/article-bio-block/article-bio-block.tsx







const ArticleBioBlock = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { articleAuthor  } = props;
    const renderAuthorAvatar = ()=>{
        if (!(articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage) || (articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage) === "") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconAuthorAvatar, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_bio_block_module_default()).articleLeadImage,
            style: {
                backgroundImage: "url('".concat(articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.leadImage, "')")
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_bio_block_module_default()).articleBioContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_bio_block_module_default()).articleAuthorAvatar,
                children: renderAuthorAvatar()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_bio_block_module_default()).articleInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (article_bio_block_module_default()).writtenBy,
                        children: "Written by"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_bio_block_module_default()).name,
                        children: articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_bio_block_module_default()).bio,
                        children: articleAuthor === null || articleAuthor === void 0 ? void 0 : articleAuthor.bio
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_bio_block_module_default()).articleLink,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_hub_button/* default */.Z, {
                    link: (0,LangHelper/* replaceOrAddLocale */.yM)("/".concat(LangHelper/* ContentHubUrlPrefix.TheLoop */.nZ.TheLoop), locale),
                    buttonText: "More Articles",
                    color: content_hub_button_constants/* COLORS.BLACK */.DM.BLACK,
                    size: content_hub_button_constants/* SIZES.SMALL */.zf.SMALL
                })
            })
        ]
    });
};
/* harmony default export */ var article_bio_block = (ArticleBioBlock);

// EXTERNAL MODULE: ./components/default-layout/index.tsx + 18 modules
var default_layout = __webpack_require__(6940);
// EXTERNAL MODULE: ./components/divider/divider.module.scss
var divider_module = __webpack_require__(3714);
var divider_module_default = /*#__PURE__*/__webpack_require__.n(divider_module);
;// CONCATENATED MODULE: ./components/divider/divider.tsx



const Divider = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (divider_module_default()).root
    });
};
/* harmony default export */ var divider = (Divider);

// EXTERNAL MODULE: ./components/meta-block/MetaBlock.tsx
var MetaBlock = __webpack_require__(2135);
// EXTERNAL MODULE: ./components/article-grid/article-grid.tsx + 2 modules
var article_grid = __webpack_require__(5211);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(1198);
// EXTERNAL MODULE: ./hooks/useAsync.ts
var useAsync = __webpack_require__(8946);
// EXTERNAL MODULE: ./components/related-articles/related-articles.module.scss
var related_articles_module = __webpack_require__(8819);
var related_articles_module_default = /*#__PURE__*/__webpack_require__.n(related_articles_module);
;// CONCATENATED MODULE: ./components/related-articles/related-articles.tsx







const LIMIT = 3;
const RelatedArticles = (param)=>{
    let { offset: offsetFromProps = 0 , article  } = param;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const [articles, setArticles] = (0,react.useState)([]);
    const [offset, setOffsetArticle] = (0,react.useState)(offsetFromProps);
    const [isLoadingMoreArticles, setIsLoadingMoreArticles] = (0,react.useState)(true);
    const loadMoreArticles = async ()=>{
        return await (0,BuilderHelper/* getRelatedArticles */.eA)(article, locale);
    };
    const getUniqueArticles = (newArticles)=>{
        const mapper = {};
        newArticles.forEach((article)=>{
            mapper[article.builderModel.id] = article;
        });
        return Object.values(mapper);
    };
    const asyncObject = (0,useAsync/* useAsync */.r)({
        asyncFunc: loadMoreArticles,
        funcParams: {},
        immediate: true
    });
    (0,react.useEffect)(()=>{
        if (!asyncObject.data) {
            asyncObject.execute();
            return;
        }
        let newArticles = [];
        if (asyncObject.data) {
            newArticles = getUniqueArticles(asyncObject.data);
        }
        setArticles(newArticles);
    }, [
        asyncObject.data
    ]);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        setIsLoadingMoreArticles(false);
        if (offset !== offsetFromProps || offset === -1) {
            setIsLoadingMoreArticles(true);
            const loadData = async ()=>{
                try {
                    const newArticles = await (0,BuilderHelper/* getRelatedArticles */.eA)(article, locale);
                    if (!cancelled && newArticles) {
                        setArticles((oldArticles)=>getUniqueArticles([
                                ...oldArticles,
                                ...newArticles
                            ]));
                    }
                } catch (e) {
                    console.error(e);
                } finally{
                    if (!cancelled) {
                        setIsLoadingMoreArticles(false);
                    }
                }
            };
            loadData();
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        offset
    ]);
    (0,react.useEffect)(()=>{
        let cancelled = false;
        setIsLoadingMoreArticles(true);
        const loadData = async ()=>{
            try {
                const newArticles = await (0,BuilderHelper/* getRelatedArticles */.eA)(article, locale);
                if (!cancelled && newArticles) {
                    setArticles(()=>getUniqueArticles(newArticles));
                }
            } catch (e) {
                console.error(e);
            } finally{
                if (!cancelled) {
                    setIsLoadingMoreArticles(false);
                }
            }
        };
        loadData();
        return ()=>{
            cancelled = true;
        };
    }, [
        article
    ]);
    if (!(articles === null || articles === void 0 ? void 0 : articles.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (related_articles_module_default()).title,
                children: "Related Posts"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid/* default */.ZP, {
                articles: articles,
                isLoadingMoreArticles: isLoadingMoreArticles,
                setOffsetArticle: setOffsetArticle,
                offsetArticle: offset,
                templateType: article_grid/* TEMPLATE_TYPE.ONE_LINE */.cP.ONE_LINE,
                itemPerPage: LIMIT,
                showLoadMore: false
            })
        ]
    });
};

// EXTERNAL MODULE: ./styles/generic.module.scss
var generic_module = __webpack_require__(4256);
var generic_module_default = /*#__PURE__*/__webpack_require__.n(generic_module);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(6612);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./hooks/useLeadImage.ts
var useLeadImage = __webpack_require__(427);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(707);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/tag/tag.module.scss
var tag_module = __webpack_require__(3718);
var tag_module_default = /*#__PURE__*/__webpack_require__.n(tag_module);
;// CONCATENATED MODULE: ./components/tag/tag.tsx



const Tag = (props)=>{
    const { link , children  } = props;
    const tagClassName = (tag_module_default()).container;
    if (link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: link,
            className: tagClassName,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: tagClassName,
        children: children
    });
};
/* harmony default export */ var tag = (Tag);

// EXTERNAL MODULE: ./components/article-hero/article-hero.module.scss
var article_hero_module = __webpack_require__(4038);
var article_hero_module_default = /*#__PURE__*/__webpack_require__.n(article_hero_module);
;// CONCATENATED MODULE: ./components/article-hero/article-hero.tsx








const ArticleHero = (props)=>{
    var ref, ref1;
    const { article  } = props;
    const category = (ref = article.categories) === null || ref === void 0 ? void 0 : ref[0];
    const author = article.author;
    const containerRef = (0,react.useRef)(null);
    const heroImage = (0,useLeadImage/* useArticleLeadImage */.X)(article);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const breadcrumbs = [
        {
            name: "The Loop",
            link: "/the-loop"
        },
        {
            name: category.name,
            link: category.categoryUrl
        },
        {
            name: article.title,
            link: ""
        }
    ];
    const transformDetector = (0,react.useCallback)(()=>{
        if (!containerRef || !containerRef.current) return;
        const targetElem = containerRef.current;
        const topOfWindow = window.scrollY;
        const windowHeight = window.innerHeight;
        const windowWidth = window.innerWidth;
        const minContainerWidth = windowWidth <= 768.98 ? 568 : 684;
        if (topOfWindow > 0) {
            targetElem.style.height = minContainerWidth + "px";
        } else {
            targetElem.style.height = Math.max(minContainerWidth, windowHeight * 0.6) + "px";
        }
    }, [
        containerRef
    ]);
    (0,react.useEffect)(()=>{
        transformDetector();
        document.addEventListener("scroll", transformDetector);
        return ()=>document.removeEventListener("scroll", transformDetector);
    }, [
        transformDetector
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: (article_hero_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_hero_module_default()).background,
                style: {
                    backgroundImage: "url(".concat(heroImage, ")"),
                    backgroundPosition: article.leadImagePosition
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_hero_module_default()).mask
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_hero_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_hero_module_default()).breadcrumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                            type: "light",
                            breadcrumbs: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (article_hero_module_default()).mainContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (article_hero_module_default()).title,
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (article_hero_module_default()).categories,
                                children: article.categories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tag, {
                                        link: category.categoryUrl ? (0,LangHelper/* replaceOrAddLocale */.yM)(category.categoryUrl, locale) : undefined,
                                        children: category.name
                                    }, category.id))
                            }),
                            author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (article_hero_module_default()).infoContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (article_hero_module_default()).authorContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: (article_hero_module_default()).authorAvatar,
                                                src: author === null || author === void 0 ? void 0 : author.leadImage,
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (article_hero_module_default()).authorNameContainer,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (article_hero_module_default()).authorBy,
                                                        children: "by\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (article_hero_module_default()).authorName,
                                                        children: (ref1 = article.author) === null || ref1 === void 0 ? void 0 : ref1.name
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (article_hero_module_default()).info,
                                        children: [
                                            "".concat(dayjs_min_default()(article.overrideDate || article.createdDate).format("MMM DD, YYYY")),
                                            article.readingTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "\xa0\xa0\xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (article_hero_module_default()).dot,
                                                        children: "•"
                                                    }),
                                                    "\xa0\xa0\xa0",
                                                    "".concat(article.readingTime, " min read")
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_hero = (ArticleHero);

// EXTERNAL MODULE: ./components/content-hub-share-icons/content-hub-share-icons.module.scss
var content_hub_share_icons_module = __webpack_require__(419);
var content_hub_share_icons_module_default = /*#__PURE__*/__webpack_require__.n(content_hub_share_icons_module);
;// CONCATENATED MODULE: ./components/content-hub-share-icons/content-hub-share-icons.utils.ts
const getUrlShare = (type, urlShare)=>{
    switch(type){
        case "facebook":
            return "https://www.facebook.com/sharer.php?u=".concat(urlShare);
        case "linkedIn":
            return "https://www.linkedin.com/sharing/share-offsite/?url=".concat(urlShare);
        case "twitter":
            return "https://twitter.com/intent/tweet?url=".concat(urlShare);
        default:
            return urlShare;
    }
};
const getTooltipMessage = (type)=>{
    switch(type){
        case "facebook":
            return "Share on Facebook";
        case "linkedIn":
            return "Share on LinkedIn";
        case "twitter":
            return "Share on Twitter";
        default:
            return "";
    }
};
const handlePopupCenter = (param)=>{
    let { url , title , popupWidth , popupHeight  } = param;
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width - popupWidth) / 2 / systemZoom + dualScreenLeft;
    const top = (height - popupHeight) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(url, title, "\n    scrollbars=yes,\n    width=".concat(popupWidth / systemZoom, ", \n    height=").concat(popupHeight / systemZoom, ", \n    top=").concat(top, ", \n    left=").concat(left, "\n    "));
    if (window === null || window === void 0 ? void 0 : window.focus) newWindow === null || newWindow === void 0 ? void 0 : newWindow.focus();
};

;// CONCATENATED MODULE: ./components/content-hub-share-icons/social-and-share-icon/facebook-social.tsx


const FacebookSocial = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.1495 17.8596C21.1495 17.7349 21.1668 17.4657 21.2014 17.0535C21.2386 16.6406 21.3945 16.2086 21.6741 15.7549C21.9511 15.303 22.4005 14.8969 23.0256 14.5376C23.648 14.1801 24.5476 14 25.7215 14H29.0288V17.6042H26.6072C26.3674 17.6042 26.144 17.6942 25.9423 17.8717C25.7423 18.0492 25.6393 18.218 25.6393 18.3747V20.617H29.0279C28.9924 21.056 28.9534 21.4828 28.9084 21.8949L28.7742 22.984C28.7206 23.352 28.666 23.6931 28.6123 24.0074H25.6151V34H21.1495V24.0065H18.9712V20.617H21.1495V17.8596Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var facebook_social = (FacebookSocial);

;// CONCATENATED MODULE: ./components/content-hub-share-icons/social-and-share-icon/linkedIn-social.tsx


const LinkedInSocial = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.6705 15.0739C15.1177 14.653 15.7014 14.4424 16.4218 14.4424C17.1423 14.4424 17.7197 14.6529 18.1536 15.0739C18.5875 15.4949 18.809 16.0265 18.8177 16.6689C18.8263 17.3026 18.6071 17.8321 18.1602 18.2573C17.7132 18.6828 17.125 18.8954 16.3957 18.8954H16.3697C15.6579 18.8954 15.0849 18.6826 14.651 18.2573C14.217 17.8321 14 17.3024 14 16.6689C14 16.0264 14.2234 15.4949 14.6705 15.0739ZM32.6458 21.832C31.7432 20.8467 30.5494 20.354 29.0651 20.354C28.5183 20.354 28.0212 20.4213 27.574 20.5559C27.127 20.6904 26.7495 20.8792 26.4413 21.1223C26.1332 21.3653 25.8878 21.591 25.7057 21.7992C25.5325 21.997 25.3631 22.2274 25.1978 22.4881V20.6533H20.9138L20.9269 21.2783C20.9357 21.6951 20.9401 22.9798 20.9401 25.1324C20.9401 27.2853 20.9314 30.0933 20.914 33.5569H25.1978V26.3563C25.1978 25.9137 25.2453 25.5622 25.341 25.3015C25.5234 24.8586 25.7987 24.4878 26.1679 24.1884C26.5369 23.8887 26.9947 23.739 27.5417 23.739C28.288 23.739 28.8373 23.9972 29.1889 24.5137C29.5404 25.0301 29.7162 25.7441 29.7162 26.6556V33.5565H34V26.1612C33.9997 24.2599 33.5486 22.8169 32.6458 21.832ZM18.5441 20.6533H14.2473V33.5568H18.5441V20.6533Z",
                fill: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            })
        ]
    });
};
/* harmony default export */ var linkedIn_social = (LinkedInSocial);

;// CONCATENATED MODULE: ./components/content-hub-share-icons/social-and-share-icon/twitter-social.tsx


const TwitterSocial = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M36 16.5585C35.1075 16.95 34.1565 17.2095 33.165 17.3355C34.185 16.7265 34.9635 15.7695 35.3295 14.616C34.3785 15.183 33.3285 15.5835 32.2095 15.807C31.3065 14.8455 30.0195 14.25 28.6155 14.25C25.8915 14.25 23.6985 16.461 23.6985 19.1715C23.6985 19.5615 23.7315 19.9365 23.8125 20.2935C19.722 20.094 16.1025 18.1335 13.671 15.147C13.2465 15.8835 12.9975 16.7265 12.9975 17.634C12.9975 19.338 13.875 20.8485 15.183 21.723C14.3925 21.708 13.617 21.4785 12.96 21.117C12.96 21.132 12.96 21.1515 12.96 21.171C12.96 23.562 14.6655 25.548 16.902 26.0055C16.5015 26.115 16.065 26.1675 15.612 26.1675C15.297 26.1675 14.979 26.1495 14.6805 26.0835C15.318 28.032 17.127 29.4645 19.278 29.511C17.604 30.8205 15.4785 31.6095 13.1775 31.6095C12.774 31.6095 12.387 31.5915 12 31.542C14.1795 32.9475 16.7625 33.75 19.548 33.75C28.602 33.75 33.552 26.25 33.552 19.749C33.552 19.5315 33.5445 19.3215 33.534 19.113C34.5105 18.42 35.331 17.5545 36 16.5585Z",
                    fill: "black"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "0.5",
                y: "0.5",
                width: "47",
                height: "47",
                rx: "23.5",
                stroke: "#EFF4FB"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(12 12)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var twitter_social = (TwitterSocial);

;// CONCATENATED MODULE: ./components/content-hub-share-icons/content-hub-share-icons.tsx






const socialAndShares = [
    {
        type: "facebook",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook_social, {})
    },
    {
        type: "linkedIn",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkedIn_social, {})
    },
    {
        type: "twitter",
        urlShare: "",
        compShare: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter_social, {})
    }
];
const SocialAndShare = (props)=>{
    const { shareUrl  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (content_hub_share_icons_module_default()).container,
        children: (socialAndShares || []).map((item)=>{
            const linkShare = getUrlShare(item.type, item.urlShare || shareUrl);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (content_hub_share_icons_module_default()).socialAndShareLink,
                onClick: ()=>{
                    handlePopupCenter({
                        url: linkShare,
                        title: getTooltipMessage(item.type),
                        popupWidth: 400,
                        popupHeight: 300
                    });
                },
                children: [
                    item.compShare,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (content_hub_share_icons_module_default()).socialAndShareTooltip,
                        children: getTooltipMessage(item.type)
                    })
                ]
            }, item.type);
        })
    });
};
/* harmony default export */ var content_hub_share_icons = (SocialAndShare);

// EXTERNAL MODULE: ./components/article-page/article-page.module.scss
var article_page_module = __webpack_require__(9286);
var article_page_module_default = /*#__PURE__*/__webpack_require__.n(article_page_module);
;// CONCATENATED MODULE: ./components/article-page/article-page.tsx













const ArticlePage = (param)=>{
    let { article , footerItems , headerItems , headerBuilderItems , stateArticle , canonicalUrl  } = param;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    if (!article) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    let targetUrl = "/".concat(locale).concat(article.articleUrl);
    if (true) {
        targetUrl = "".concat((window === null || window === void 0 ? void 0 : window.origin) || "", "/").concat(locale).concat(article.articleUrl);
    }
    var _seoTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaBlock/* default */.Z, {
                title: (_seoTitle = article.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : article.title,
                description: article.seoDescription,
                leadImage: article.leadImage,
                canonicalUrl: canonicalUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(default_layout/* default */.Z, {
                footerItems: footerItems,
                headerItems: headerItems,
                headerBuilderItems: headerBuilderItems,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (generic_module_default())["page-layout"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(article_hero, {
                            article: article
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(content_hub_share_icons, {
                            shareUrl: targetUrl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                            model: "article",
                            content: stateArticle.builderModel
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (article_page_module_default()).layoutContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (article_page_module_default()).authorBlock,
                                    children: article.author && /*#__PURE__*/ (0,jsx_runtime.jsx)(article_bio_block, {
                                        articleAuthor: article.author
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedArticles, {
                            article: article,
                            offset: 0
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var article_page = (ArticlePage);


/***/ }),

/***/ 707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(6899);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
;// CONCATENATED MODULE: ./components/Icon/Icons/IconArrowRight.tsx


const IconArrowRight = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "icon-arrow",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M5 9L8 6L5 3",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_IconArrowRight = (IconArrowRight);

// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.module.scss
var breadcrumb_module = __webpack_require__(3964);
var breadcrumb_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumb_module);
;// CONCATENATED MODULE: ./components/breadcrumb/breadcrumb.tsx






const Breadcrumb = (props)=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { breadcrumbs , type  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (breadcrumb_module_default()).breadcrumbContainer + " " + (breadcrumb_module_default())["".concat(type)],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (breadcrumb_module_default()).breadcrumb,
            children: (breadcrumbs || []).map((breadcrumb, index)=>{
                const linkTags = {
                    href: ""
                };
                var _link;
                const linkUrl = (0,LangHelper/* localifyLink */.Bj)((_link = breadcrumb.link) !== null && _link !== void 0 ? _link : "", locale);
                if (linkUrl) {
                    linkTags.href = "/".concat(locale).concat(linkUrl);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).separator,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_IconArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (breadcrumb_module_default()).breadcrumbName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                ...linkTags,
                                passHref: true,
                                target: "_self",
                                className: (breadcrumb_module_default()).link,
                                dangerouslySetInnerHTML: {
                                    __html: "".concat(breadcrumb.name)
                                }
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var breadcrumb = (Breadcrumb);


/***/ }),

/***/ 1200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7868);
/* harmony import */ var _content_hub_button_content_hub_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9309);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9163);
/* harmony import */ var _not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4__);





const NotFound = ()=>{
    var ref;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pageNotFound),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().number),
                children: "404"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().info),
                children: "Oops! The page you are looking for doesn’t exist. Try the button below..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "/",
                className: (_not_found_module_scss__WEBPACK_IMPORTED_MODULE_4___default().buttonBack),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_content_hub_button_content_hub_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    buttonText: "Back to home",
                    link: (ref = _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_2__/* .LOCALE_LINKS */ .kV[locale]) === null || ref === void 0 ? void 0 : ref.home
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotFound);


/***/ }),

/***/ 427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useArticleLeadImage; },
/* harmony export */   "q": function() { return /* binding */ useCategoryLeadImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2991);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8046);


const useArticleLeadImage = (article)=>{
    const { width =0  } = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .i)();
    const [heroImage, setHeroImage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(article.leadImage || article.leadPortraitImage);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (width <= 768) {
            setHeroImage(article.leadPortraitImage || article.leadImage);
        } else {
            setHeroImage(article.leadImage || article.leadPortraitImage);
        }
    }, [
        width,
        article
    ]);
    return heroImage;
};
const useCategoryLeadImage = (category)=>{
    const { width =0  } = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_1__/* .useWindowSize */ .i)();
    const [heroImage, setHeroImage] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(category.image || category.landscapeImage);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (width <= 768) {
            setHeroImage(category.landscapeImage || category.image);
        } else {
            setHeroImage(category.image || category.landscapeImage);
        }
    }, [
        width,
        category
    ]);
    return heroImage;
};


/***/ }),

/***/ 2457:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleBioContainer":"article-bio-block_articleBioContainer__qfg_I","articleAuthorAvatar":"article-bio-block_articleAuthorAvatar__lrHrV","articleLeadImage":"article-bio-block_articleLeadImage__8ulng","articleInfo":"article-bio-block_articleInfo__H2aO9","writtenBy":"article-bio-block_writtenBy__20RAF","name":"article-bio-block_name__YSh7d","bio":"article-bio-block_bio__S2563","articleLink":"article-bio-block_articleLink__xkX9D","video-spin":"article-bio-block_video-spin__LmEwv"};

/***/ }),

/***/ 4038:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"article-hero_container__Q_xqP","background":"article-hero_background__KyDdL","mask":"article-hero_mask__uw_Ic","content":"article-hero_content__Lcmms","breadcrumb":"article-hero_breadcrumb__ylAYO","mainContent":"article-hero_mainContent__1rh3v","title":"article-hero_title__TZSCu","categories":"article-hero_categories__KhxDq","infoContainer":"article-hero_infoContainer__hGisd","authorContainer":"article-hero_authorContainer__3YB_f","authorAvatar":"article-hero_authorAvatar__rAi_m","authorNameContainer":"article-hero_authorNameContainer__2v5DY","authorBy":"article-hero_authorBy__xYbnt","authorName":"article-hero_authorName__3sKLC","info":"article-hero_info__DLacR","video-spin":"article-hero_video-spin__lM26G"};

/***/ }),

/***/ 9286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authorBlock":"article-page_authorBlock__VuUv2","layoutContainer":"article-page_layoutContainer__rkkRi","video-spin":"article-page_video-spin__OsrQ5"};

/***/ }),

/***/ 3964:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"breadcrumb_breadcrumbContainer__PXHE5","light":"breadcrumb_light__eyy6t","separator":"breadcrumb_separator__0KuRL","dark":"breadcrumb_dark__T0QBm","container":"breadcrumb_container__WEljr","breadcrumb":"breadcrumb_breadcrumb__4T6Pp","video-spin":"breadcrumb_video-spin__qObMd"};

/***/ }),

/***/ 419:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"content-hub-share-icons_container__C_AXu","socialAndShareLink":"content-hub-share-icons_socialAndShareLink__Qorl7","socialAndShareTooltip":"content-hub-share-icons_socialAndShareTooltip__L0ric","video-spin":"content-hub-share-icons_video-spin__hrUsQ"};

/***/ }),

/***/ 3714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"divider_root__2tDJO","video-spin":"divider_video-spin__EpXEX"};

/***/ }),

/***/ 9163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"not-found_pageNotFound__ODQu6","number":"not-found_number__TljVQ","info":"not-found_info__eH281","buttonBack":"not-found_buttonBack__CZKRo","video-spin":"not-found_video-spin__tw1Iz"};

/***/ }),

/***/ 8819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"related-articles_title__yBIj4","video-spin":"related-articles_video-spin__76pd_"};

/***/ }),

/***/ 3718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"tag_container__7wzOc","video-spin":"tag_video-spin__24vPh"};

/***/ })

}]);